import React, {Component} from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import classnames from 'classnames'
import moment from 'moment'

import { airportNameLocByIata } from '../airport/airportUtils'
import Airline from '../offer/Airline'
import CabinClass from '../offer/CabinClass'
import Flight from '../offer/Flight'
import { countStops } from '../offer/filters/stops/stops'

import './FlightDetail.css'

class FlightDetail extends Component {
  constructor()
  {
    super()
    this.state = {
      flightDetailCollapsed: false
    }
  }

  componentWillMount()
  {
    this.setState({
      flightDetailCollapsed: this.props.defaultCollapseState === undefined ? true : this.props.defaultCollapseState
    })
  }

  toggleFlightDetailCollapse = (e) =>
  {
    if (e && e.preventDefault)
    {
      e.preventDefault()
    }
    this.setState({
        flightDetailCollapsed: !this.state.flightDetailCollapsed
      }
    )
  }

  render()
  {
    const {serviceDetail, airportByIata} = this.props
    const stopCount = countStops(serviceDetail)

    const mComplete = moment( serviceDetail.get('complete') )
    const mCommence = moment( serviceDetail.get('commence') )
    const duration = moment.duration( serviceDetail.get('duration') )

    return <div className="row result-item booking-item">
          <div className="col-sm-3 col-lg-4 airline-col">
              <Airline airline={serviceDetail.get('serviceProvider')} />
          </div>
          <Flight serviceDetail={serviceDetail} airportByIata={airportByIata} />
          <div className="col-sm-4 col-lg-3 class-col">
              <CabinClass serviceDetail={serviceDetail} />
          </div>
          <div className="col-sm-5 col-lg-4 show-details-col">
            <div className="col-wrapper-va">
              <div className="v-align">
                <a className={classnames({'show-details':true, 'collapsed': this.state.flightDetailCollapsed})} style={{cursor:"pointer"}} onClick={this.toggleFlightDetailCollapse.bind(this)}><span>Show Details</span><span>Hide Details</span></a>
              </div>
            </div>
          </div>
          <ul className={classnames({'flights-connections': true, 'collapse': true, 'in':!this.state.flightDetailCollapsed})}>
            {stopCount > 0 ?
              serviceDetail.get("connectingFlightDetail").map((csd, i)=>{
                return <li key={i}>{i>0?<ConnectionInfo serviceDetail={serviceDetail} flightIndex={i} oneStopOnly={stopCount===1}/>:null}
                    <FlightLeg commences={mCommence} serviceDetail={csd} airportByIata={airportByIata}/>
                </li>
              }) : <li><FlightLeg commences={mCommence} serviceDetail={serviceDetail} airportByIata={airportByIata}/></li>
            }
            <li className="flight-details-footer">
              <span className="no-wrap"><strong>Arrives:</strong>{` ${mComplete.format("ddd, DD MMM YYYY")}`}</span> <i>|</i> <span className="no-wrap"><strong>Journey duration:</strong> {Math.floor(duration.asHours())}h{duration.minutes()
                  ? ` ${duration.minutes()}m`
                  : ''}</span>
            </li>
          </ul>
          <i className="tl-corner"></i>
        </div>
  }
}

FlightDetail.propTypes = {
    // ServiceDetailAsMap
    serviceDetail : ImmutablePropTypes.map.isRequired,
    // Map<IataCode,AirportAsMap>
    airportByIata : ImmutablePropTypes.map.isRequired
}

const ConnectionInfo = ({serviceDetail, flightIndex, oneStopOnly})=>{
  const mComplete = moment( serviceDetail.get('connectingFlightDetail').get(flightIndex-1).get("complete") )
  const mCommence = moment( serviceDetail.get('connectingFlightDetail').get(flightIndex).get("commence") )
  const stopDuration = moment.duration(mCommence.diff(mComplete))

  return <div className="connection-info row">
          <div className="col-xs-6 col-sm-4 col-md-3">
            <div className="col-wrapper-va">
              <div className="v-align">
                <span className="duration" title="Travel Time">{Math.floor(stopDuration.asHours())}h{stopDuration.minutes()
                    ? ` ${stopDuration.minutes()}m`
                    : ''}</span>
              </div>
            </div>
          </div>
          <div className="col-xs-18 col-sm-20 col-md-21 additional-info-col">
            <div className="col-wrapper-va">
              <div className="v-align">
                <span>Connect in airport</span>{stopDuration.hours()>2?<strong className="additional-info hidden-xs">Long wait</strong>:null}
              </div>
            </div>
          </div>
        </div>
}

const FlightLeg = ({commences, serviceDetail, airportByIata}) => {
  const serviceProvider = serviceDetail.get("serviceProvider");
  // const serviceProviderIdentifier = serviceProvider.getIn(['industryIdentifier','identifier']);
  const serviceProviderName = serviceProvider.get('name');

  const fromUri = serviceDetail.get('from','')
  const fromIata = fromUri.substring(fromUri.length - 3)
  const toUri = serviceDetail.get('to','')
  const toIata = toUri.substring(toUri.length - 3)

  const mCommence = moment( serviceDetail.get('commence') )
  const mComplete = moment( serviceDetail.get('complete') )
  const overnight = mComplete.diff( mCommence, 'days') > 0;
  const sameDay = mCommence.isSame(commences,'day')

  const duration = moment.duration( serviceDetail.get('duration') )

  return <div><h5>
    <div className="segment-title">
      <div className="col-xs-4"><Airline airline={serviceProvider} /></div>
      <div className="col-xs-14"><div className="col-wrapper-va">
        <span className="v-align">{serviceProviderName} {serviceDetail.has("flightNumber")? `(${serviceDetail.get("flightNumber")})`:''}</span></div></div>
      <div className="col-xs-6">{overnight? <span className="additional-info hidden-xs">Overnight Flight</span>:null}</div>
    </div>
  </h5>
  <div className="row">
    <div className="col-xs-24 col-sm-14 col-md-15 col-sm-push-4 col-md-push-3">
      <div className="col-wrapper-va">
        <dl className="v-align flight-from-to">
          <dt><time>{`${mCommence.format('HH:mm')}`}<sup>{sameDay? '' : `+${mCommence.diff( commences, 'days') > 0 ? mCommence.diff( commences, 'days'): `1`}d`}</sup></time> {airportNameLocByIata(fromIata, airportByIata)}</dt>
          <dd><time>{`${mComplete.format('HH:mm')}`}<sup>{sameDay? '' : `+${mComplete.diff( commences, 'days') > 0 ? mComplete.diff( commences, 'days'): `1`}d`}</sup></time> {airportNameLocByIata(toIata, airportByIata)}</dd>
        </dl>
      </div>
    </div>
    <div className="col-xs-24 col-sm-4 col-md-3 col-sm-pull-14 col-md-pull-15" style={{paddingRight:"0px"}}>
      <div className="col-wrapper-va">
        <div className="v-align">
          <span className="duration" title="Travel Time">{Math.floor(duration.asHours())}h{duration.minutes()
              ? ` ${duration.minutes()}m`
              : ''}</span>
        </div>
      </div>
    </div>
    <div className="col-sm-6 col-xs-12 hidden-xs">
      <div className="col-wrapper-va">
        <div className="v-align">
          <CabinClass serviceDetail={serviceDetail} />
        </div>
      </div>
    </div>
  </div></div>
}

export default FlightDetail



// WEBPACK FOOTER //
// ./src/ndc/booking/FlightDetail.js